import { useLocation } from '@reach/router'
import { useSeoPagesApiData } from './useSeoPagesApiData'
import { useInternalRoutesApiData } from './useInternalRoutesApiData'

import { getWebsiteUrl } from '../../utils/getWebsiteUrl'

const websiteURL = getWebsiteUrl()

export const useHrefLangApiData = ({ hrefLangPage, href_langs, slugsData }) => {
  const location = useLocation()
  const { seoContent, locationPath } = useSeoPagesApiData(true)
  const { currentRoute } = useInternalRoutesApiData(locationPath)

  const hrefLangs = []

  seoContent?.forEach((seoPage) => {
    if (location?.href?.includes(seoPage.path)) {
      const index = location?.href?.indexOf(seoPage.path)
      const locationPath = location?.href?.slice(index)
      if (seoPage.path === '/' && location?.href === websiteURL) {
        hrefLangs.push(...seoPage.href_langs)
      } else if (locationPath === seoPage.path) {
        hrefLangs.push(...seoPage.href_langs)
      }
    }
  })

  currentRoute?.href_langs?.forEach(({ href_lang, url }) => {
    hrefLangs?.push({
      url,
      href_lang,
    })
  })

  if (hrefLangPage) {
    const route = slugsData[0].slugs.filter((slug) => {
      return slug.generic_route === hrefLangPage
    })[0]
    if (route?.href_langs) hrefLangs.push(...(route?.href_langs ?? []))
  }
  if (href_langs?.length > 0) hrefLangs.push(...href_langs)

  const filteredDuplicatedHrefLangs = hrefLangs.filter(
    (obj, index) =>
      hrefLangs.findIndex(
        (item) => item.url === obj.url && item.href_lang === obj.href_lang
      ) === index
  )

  return {
    hrefLangApiData: filteredDuplicatedHrefLangs || [],
  }
}
